TnStoreErrorHandlingConfig.$inject = ['$provide'];
export function TnStoreErrorHandlingConfig($provide) {
    $provide.decorator('$exceptionHandler', ExceptionHandlerDecorator);
}
ExceptionHandlerDecorator.$inject = ['$delegate'];
function ExceptionHandlerDecorator($delegate) {
    return function (exception, cause) {
        // raise original handler
        $delegate(exception, cause);
    };
}
